import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const sharedTexts: Record<string, IOnboardingStepText> = {
  'task.performer': {
    title: 'Исполнитель',
    text: 'Кто отвечает за задачу. Если есть права, исполнителя можно сменить кликом.',
  },
  'task.deadline': {
    title: 'Срок',
    text: 'Крайний срок выполнения. Просроченная задача помечается красным.',
  },
  'task.checklist': {
    title: 'Чек-лист',
    text: 'Пункты, которые нужно отметить по ходу работы. Незакрытые пункты напомнят о себе при завершении.',
  },
  'task.subtask': {
    title: 'Подзадачи',
    text: 'Разбейте работу на части и поручите их другим сотрудникам.',
  },
  'task.observers': {
    title: 'Наблюдатели',
    text: 'Сотрудники, которые получают уведомления о ходе задачи, но не исполняют её.',
  },
  'task.menu': {
    title: 'Меню задачи',
    text: 'Срочность, закрепление в списке, ссылка на задачу и удаление.',
  },
  'task.statusActions': {
    title: 'Ход работы',
    text: 'Возьмите задачу в работу, а по окончании отчитайтесь. Если отчёт обязателен, без него задачу не завершить.',
  },
  'ear.chat': {
    title: 'Чат',
    text: 'Обсуждение с участниками прямо в карточке. Переписка привязана к этой записи.',
  },
  'ear.files': {
    title: 'Документы и ссылка',
    text: 'Скачать печатную форму, сформировать отчёт или скопировать ссылку, чтобы отправить коллеге.',
  },
  'ear.onboarding': {
    title: 'Обучение',
    text: 'Пройти обучение заново можно в любой момент — по этой кнопке.',
  },
  'toolbar.reports': {
    title: 'Формы и отчёты',
    text: 'Готовые печатные формы и отчёты по записям с учётом текущих фильтров.',
  },
  'toolbar.onboarding': {
    title: 'Обучение',
    text: 'Пройти обучение по разделу заново можно в любой момент — по этой кнопке.',
  },
}
